import apiClient from "./apiClient";

export const getStaffCalendar = async (startDate?: string, finishDate?: string, projectId?: number): Promise<any[]> => {
  try {
      const response = await apiClient.get('/StaffCalendar', {
          params: {
              ...(startDate && { startDate }),
              ...(finishDate && { finishDate }),
              ...(projectId && { projectId }) 
          }
      });
      return response.data;
  } catch (error) {
      console.error('Error al obtener el calendario del personal:', error);
      throw new Error('Error al obtener el calendario del personal.');
  }
};